import { withInstall, withNoopInstall } from '@lit-element/utils'
import Tour from './src/tour.vue'
import TourStep from './src/step.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTour: SFCWithInstall<typeof Tour> & {
  TourStep: typeof TourStep
} = withInstall(Tour, {
  TourStep,
})
export const LtTourStep: SFCWithInstall<typeof TourStep> =
  withNoopInstall(TourStep)
export default LtTour

export * from './src/tour'
export * from './src/step'
export * from './src/content'
export type { TourMask, TourGap, TourBtnProps } from './src/types'
